import { render, staticRenderFns } from "./lifeExpertSearch.vue?vue&type=template&id=28767260&scoped=true&"
import script from "./lifeExpertSearch.vue?vue&type=script&lang=js&"
export * from "./lifeExpertSearch.vue?vue&type=script&lang=js&"
import style0 from "./lifeExpertSearch.vue?vue&type=style&index=0&id=28767260&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28767260",
  null
  
)

export default component.exports